module.exports = __webpack_public_path__ + "img/portraits_28_V.54f4e3a3.webp";